import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updatePlayField =
	(fieldKey: string, maxSpend: number) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, fieldRemote, createAnalyticsEvent }: Props,
	): Promise<void> => {
		const state = getState();
		const field = state.fields[fieldKey];

		try {
			if (field?.play?.id === undefined) {
				onFieldUpdateFailed(new Error('Updated failed: field without id cannot be updated'));
				return;
			}

			await fieldRemote.updatePlayField({
				id: field.play.id,
				parameters: { maxSpend },
			});

			const oldMaxSpend = field.play?.parameters?.maxSpend;
			await fieldRemote.updateFieldConfiguration({
				fieldKey,
				configuration: {
					maxSpend,
				},
				oldConfiguration: oldMaxSpend ? { maxSpend: oldMaxSpend } : {},
				type: 'updatePlayField',
			});

			setState({
				fields: {
					...state.fields,
					[fieldKey]: {
						...field,
						play: {
							// oxlint-disable-next-line typescript/no-non-null-assertion
							...field.play!,
							parameters: {
								...field.play?.parameters,
								maxSpend,
							},
						},
					},
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'issueFields updated', {
				updatedItems: [{ name: 'play.maxSpend' }],
				issueFieldKey: fieldKey,
				issueFieldType: field?.type,
			});
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			onFieldUpdateFailed(error);
		}
	};
